module.exports = __webpack_public_path__ + "static/caligator2-b80232ffc975d18a1981b0cb1a569724.gif";